import { render, staticRenderFns } from "./LegalEntityProfile.vue?vue&type=template&id=50890802&scoped=true&"
import script from "./LegalEntityProfile.vue?vue&type=script&lang=js&"
export * from "./LegalEntityProfile.vue?vue&type=script&lang=js&"
import style0 from "./LegalEntityProfile.vue?vue&type=style&index=0&id=50890802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50890802",
  null
  
)

export default component.exports